/**
 * <et-sfs-announcement-bar>
 *
 * Desktop: the marquee is pure CSS (the item list is duplicated in Liquid so the
 * -50% keyframe loops seamlessly).
 * Mobile: a simple one-slide-at-a-time slider with prev/next arrows and an
 * autoplay interval; autoplay pauses once the visitor uses an arrow.
 *
 * Countdown elements ([data-et-sfs-countdown]) tick down to their data-ends-at
 * timestamp and restart on the configured cycle when it lapses.
 */
if (!customElements.get('et-sfs-announcement-bar')) {
  class EtSfsAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.et-sfs-ab__slide'));
      this.index = 0;
      this.interval = parseInt(this.dataset.autoplay, 10) || 0;

      if (this.slides.length > 1) {
        this.prev = this.querySelector('.et-sfs-ab__arrow--prev');
        this.next = this.querySelector('.et-sfs-ab__arrow--next');

        if (this.prev) {
          this.prev.addEventListener('click', () => {
            this.stopAutoplay();
            this.go(this.index - 1);
          });
        }
        if (this.next) {
          this.next.addEventListener('click', () => {
            this.stopAutoplay();
            this.go(this.index + 1);
          });
        }

        this.startAutoplay();
      }

      this.startCountdowns();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.countdownTimer) window.clearInterval(this.countdownTimer);
    }

    go(next) {
      const total = this.slides.length;
      this.index = ((next % total) + total) % total;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
      });
    }

    startAutoplay() {
      if (!this.interval) return;
      this.stopAutoplay();
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    startCountdowns() {
      this.countdowns = Array.from(this.querySelectorAll('[data-et-sfs-countdown]'));
      if (!this.countdowns.length) return;

      this.tickCountdowns();
      this.countdownTimer = window.setInterval(() => this.tickCountdowns(), 1000);
    }

    tickCountdowns() {
      const now = Date.now();

      this.countdowns.forEach((el) => {
        let endsAt = parseInt(el.dataset.endsAt, 10);
        const cycle = parseInt(el.dataset.cycle, 10) || 0;

        if (!endsAt) return;

        // Roll the deadline forward so an evergreen timer never shows zeroes
        if (endsAt <= now && cycle > 0) {
          while (endsAt <= now) endsAt += cycle;
          el.dataset.endsAt = endsAt;
        }

        const remaining = Math.max(0, endsAt - now);
        const totalSeconds = Math.floor(remaining / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const pad = (n) => String(n).padStart(2, '0');
        const set = (name, value) => {
          const target = el.querySelector(`[data-unit="${name}"]`);
          if (target) target.textContent = value;
        };

        set('hours', pad(hours));
        set('minutes', pad(minutes));
        set('seconds', pad(seconds));
      });
    }
  }

  customElements.define('et-sfs-announcement-bar', EtSfsAnnouncementBar);
}
